/* RRTC — autoplay/pause controller for the Video promo section.
   Autoplay only works muted + playsinline; everything else here is about not
   wasting the visitor's battery and honouring reduced-motion preferences. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(video) {
    if (video.__vpReady) return;
    video.__vpReady = true;

    // Attributes, not just properties: iOS needs them present on the element.
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;

    var playBtn = video.parentNode.querySelector('[data-video-promo-play]');
    var wantsPlay = !REDUCED;

    function play() {
      if (!wantsPlay) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        // Autoplay can still be refused (data saver, low power mode).
        p.catch(function () { if (playBtn) playBtn.hidden = false; });
      }
    }
    function pause() { if (!video.paused) video.pause(); }

    if (playBtn) {
      playBtn.hidden = !REDUCED;
      playBtn.addEventListener('click', function () {
        wantsPlay = true;
        playBtn.hidden = true;
        play();
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.isIntersecting ? play() : pause(); });
      }, { threshold: 0.25, rootMargin: '200px 0px' });   // rows use preload="none": begin loading just before they scroll in
      io.observe(video);
    } else {
      play();
    }

    // The theme editor re-renders sections; re-arm on section load.
    document.addEventListener('shopify:section:load', function () { play(); });
  }

  function scan() {
    document.querySelectorAll('video[data-video-promo]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
})();
